import React, { Component } from 'react';
import Tooltip from '../Tooltip';

import PropTypes from 'prop-types';

class FieldLabelToolTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: this.props.tooltip,
      showTooltip: false,
      fieldUniqueName: this.props.name
    }
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.state.fieldUniqueName}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.state.fieldUniqueName}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  render() {
    return (
      <div className={this.props.className ? this.props.className : ""}>
        <button
          onMouseEnter={this.toggleTooltip}
          onMouseLeave={this.toggleTooltip}
          onClick={this.toggleTooltip}
          onKeyUp={(event) => this.toggleTooltiponEnter(event)}
          aria-describedby={`${this.state.fieldUniqueName}tooltip`}
          className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon"
          data-tooltip={this.state.fieldUniqueName}
          aria-expanded="false"
          aria-label={`Additional Information on ${this.props.label}`}
          style={this.props.style}
        >
        </button>
        <Tooltip
          active={this.state.showTooltip}
          position="right"
          arrow="center"
          parent={this.state.fieldUniqueName}
        >
          <div className="tooltip-content-hintText">
            <span role="status" id={`${this.state.fieldUniqueName}tooltip`}>{this.state.tooltip}</span>
          </div>
        </Tooltip>
      </div>
    )
  }
}


FieldLabelToolTip.propTypes = {
  tooltip: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}


export default FieldLabelToolTip;



// WEBPACK FOOTER //
// ./src/components/common/FieldLabelToolTip/fieldLabelToolTip.js